import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { OperacaoFinanceiraEditarComponent } from "./operacao-financeira-editar.component";
import { OperacaoFinanceiraEditarRoutingModule } from "./operacao-financeira-editar-routing.module";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import {InputSwitchModule} from 'primeng/inputswitch';
import { ProgressSpinnerModule } from "primeng/progressspinner";



@NgModule({
    imports: [
        CommonModule,            
        OperacaoFinanceiraEditarRoutingModule,
        FormsModule,
        HttpClientModule,        
        ButtonModule,
        InputTextModule,
        DividerModule,
        DropdownModule,
        InputMaskModule,
        MessagesModule,
        InputSwitchModule,
        ProgressSpinnerModule

    ],
    declarations: [OperacaoFinanceiraEditarComponent]
})
export class OperacaoFinanceiraEditarModule { }
